import React from 'react';
import PropTypes from 'prop-types';
import { StoreProvider } from 'easy-peasy';
import store from './src/lib/EasyPeasy';
import { ApolloProvider } from '@apollo/react-hooks';
import { client } from '@lib/apolloClient';
const wrapWithProvider = ({ element }) => (
  <ApolloProvider client={client}>
    <StoreProvider store={store}>{element}</StoreProvider>
  </ApolloProvider>
);
wrapWithProvider.propTypes = {
  element: PropTypes.node.isRequired
};
export default wrapWithProvider;
